import Comp from '../../../../../../ManagementApp/wwwroot/client/src/views/components/StorefrontIntegrationSystemSelect.vue';
export default Comp;
